import { useEffect, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useHreflang } from "../i18n/hooks/useHreflang";
import { getLocaleFromPath } from "../i18n/config";
import { metadataTranslations } from "../i18n/metadata";
import { useDispatch, useSelector } from "react-redux";
import ArticleFeatured from "../components/ArticleFeatured";
import ArticleItem from "../components/ArticleItem";
import { getBlogsRequest } from "../redux/actions";
import { AppState } from "../redux/types";

const Health = () => {
    const hreflang = useHreflang("happysenior_blogi");
    const locale = getLocaleFromPath();
    const meta = metadataTranslations.blog_list[locale] || metadataTranslations.blog_list.fi;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getBlogsRequest());
        return () => {};
    }, [dispatch]);

    const _blogs = useSelector((state: AppState) => state.blogs.blogs);

    // Defensive checks against empty values
    const blogs = useMemo(() => {
        const arr = Array.isArray(_blogs) ? _blogs.filter(Boolean) : [];
        return [...arr].sort((a, b) => {
            const av = Number(a?.orderValue) || 0;
            const bv = Number(b?.orderValue) || 0;
            return av - bv;
        });
    }, [_blogs]);

    const featured_article = blogs.find((el) => el?.featured) ||
        blogs[0] || {
            id: null,
            url: "",
            title: "",
            content: "",
            contentPreview: "",
            coverType: "Image",
            cover: "",
            createdAt: "",
            createdBy: "admin ",
            featured: false,
            orderValue: 0,
            publishedAt: "",
            topics: null,
            updatedAt: "",
        };

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <link rel="alternate" hrefLang="fi" href={hreflang.fi} />
                <link rel="alternate" hrefLang="en" href={hreflang.en} />
                <link rel="alternate" hrefLang="sv" href={hreflang.sv} />
                <link rel="alternate" hrefLang="x-default" href={hreflang.fi} />
            </Helmet>
            <div className="blog-wrapper"></div>
            {!!featured_article.id && <ArticleFeatured featured_article={featured_article} />}
            <div className="blog-wrapper">
                <Row className="blog-items">
                    {blogs
                        ?.filter((el) => el?.id !== featured_article?.id)
                        ?.map((item) => {
                            return (
                                <Col
                                    md={4}
                                    style={{
                                        marginBottom: 48,
                                    }}
                                    key={`col_article_${item?.id}`}
                                >
                                    <ArticleItem item={item} />
                                </Col>
                            );
                        })}
                </Row>
            </div>
        </>
    );
};

export default Health;
